import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from "react-router-dom"
import App from './App'
import * as serviceWorker from './serviceWorker'
import { AudioProvider } from "./context/audioContext"
import { VideoProvider } from "./context/videoContext"

ReactDOM.render(
  <VideoProvider>
    <AudioProvider>
      <Router>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </Router>
    </AudioProvider>
  </VideoProvider>,
  document.getElementById( 'root' )
);

serviceWorker.register();
